import classnames from "classnames";
import * as React from "react";

import InnerModal, {
  InnerModalProps
} from "features/common/modals/components/InnerModal";
import ModalWithTheme from "features/common/modals/components/ModalWithTheme";

import styles from "./WarningModalWithTheme.module.scss";

type Props = InnerModalProps & {
  modalClassName?: string;
  clickToExit?: boolean;
  quitDestination?: any;
};

export default function WarningModalWithTheme(props: Props) {
  const {
    modalClassName,
    overlayLink,
    onCancelClick,
    innerModalClassName,
    children,
    clickToExit,
    quitDestination,
    backButtonText,
    ...other
  } = props;

  return (
    <ModalWithTheme
      className={classnames(styles.ModalWithThemeWidth, modalClassName)}
      open
      overlayLink={overlayLink}
      closeModal={onCancelClick}
      clickToExit={
        typeof clickToExit === "boolean"
          ? clickToExit
          : !!overlayLink || !!onCancelClick
      }
    >
      <InnerModal
        primaryButtonType={["carnation", "smallText"]}
        overlayLink={overlayLink}
        onCancelClick={onCancelClick}
        primaryButtonClickTo={quitDestination}
        backButtonText={backButtonText}
        innerModalClassName={classnames(
          styles.innerModalWithTheme,
          innerModalClassName
        )}
        {...other}
      >
        {children}
      </InnerModal>
    </ModalWithTheme>
  );
}
